<!-- <div class="success-popup">
    <div class="success-icon">✉</div>
    <div class="success-message">
      Email has been sent successfully.
    </div>
  </div> -->
  <div class="success-overlay">

    <div class="success-popup">
  
      <div class="success-icon">
        ✉
      </div>
  
      <div class="success-message">
        Email has been sent successfully.
      </div>
  
    </div>
  
  </div>
  